import React from 'react';

import { formatLinkBlockToUrl } from '$utilities/format';
import { isLocalURL } from '$utilities/browser';
import { Media } from '$partials/media';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/modules.d.ts').ColumnTextMediaBlock}
 */
const ColumnTextMedia = ({
    autoplay,
    backgroundColor,
    ctaCssClass,
    ctaMobileUrlOverride,
    ctaLabel,
    ctaLink,
    media,
    richText,
    title
}) => {
    const isCtaLinkLocal = isLocalURL(formatLinkBlockToUrl(ctaLink));

    return (
        <section className={`col-wrapper-breakout bg-surface-panel-${backgroundColor} rounded-lg pt-24 pb-8 md:pb-16 flex flex-wrap`}>
            <div className='col-padding w-full sm:w-6/12'>
                <h2 className='type-style-sans-h1 mb-8 w-full md:w-4/6'>
                    {title}
                </h2>

                {richText && (
                    <div
                        className='rich-text type-style-sans-h3 column-text-media md:pr-[156px]'
                        dangerouslySetInnerHTML={{__html:richText}} />
                )}

                {ctaLabel && (
                    <div>
                        {ctaMobileUrlOverride ? (
                            <>
                                <a
                                    className='sm:hidden button-primary-xl mt-24 md:mt-40 self-start'
                                    href={ctaMobileUrlOverride}
                                    rel='noreferrer'
                                    target='_blank'>
                                    {ctaLabel}
                                </a>
                                <a
                                    className={`hidden sm:inline-block button-primary-xl mt-24 md:mt-40 self-start${ctaCssClass ? ' ' + ctaCssClass : ''}`}
                                    href={formatLinkBlockToUrl(ctaLink)}
                                    rel={isCtaLinkLocal ? undefined : 'noreferrer'}
                                    target={isCtaLinkLocal ? undefined : '_blank' }>
                                    {ctaLabel}
                                </a>
                            </>
                        ) : (
                            <a
                                className={`button-primary-xl mt-24 md:mt-40 self-start${ctaCssClass ? ' ' + ctaCssClass : ''}`}
                                href={formatLinkBlockToUrl(ctaLink)}
                                rel={isCtaLinkLocal ? undefined : 'noreferrer'}
                                target={isCtaLinkLocal ? undefined : '_blank' }>
                                {ctaLabel}
                            </a>
                        )}
                    </div>
                )}
            </div>

            {media && (
                <figure className={`w-full sm:w-6/12 col-padding rounded-lg overflow-hidden ${media.image ? 'h-[193px]' : 'h-auto' } sm:h-[264px] md:h-[382px]`}>
                    <Media {
                        ...{
                            ...media,
                            ...(media.image ? {
                                image: {
                                    ...media?.image,
                                    className: 'h-full w-full object-cover',
                                    containerStyle: {
                                        height: '100%'
                                    },
                                    containerClassName: 'rounded-lg overflow-hidden pointer-events-none select-none'
                                }
                            } : {}),
                            ...(media.videoEmbed ? {
                                videoEmbed: {
                                    ...media.videoEmbed,
                                    autoPlay: autoplay,
                                    poster: media?.videoEmbed?.poster || media?.videoEmbed?.embed?.thumbnailUrl
                                }
                            } : {} ),
                            ...(media.video ? {
                                video: {
                                    ...media.video,
                                    autoPlay: autoplay,
                                    showControls: !autoplay,
                                    loop: autoplay,
                                }
                            } : {} )
                        }
                    }/>
                </figure>
            )}
        </section>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default ColumnTextMedia;
